module.exports = __webpack_public_path__ + "img/Blue Canvas.21e40eed.jpg";